//
//  DocumentationLegacyItemConfiguration.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyItemHeader, } from "./SDKDocumentationLegacyItemHeader";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyItemConfiguration {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.header = new DocumentationLegacyItemHeader(model.header);
        this.showSidebar = model.showSidebar;
        this.isPrivate = model.isPrivate;
        this.isHidden = model.isHidden;
    }
    toWriteModel() {
        return {
            header: this.header.toWriteModel(),
            showSidebar: this.showSidebar,
            isHidden: this.isHidden,
            isPrivate: this.isPrivate,
        };
    }
}
